var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value()),expression:"value()"}],staticClass:"wrap",attrs:{"title":_vm.title}},[_c('Loading',{staticClass:"loading",attrs:{"size":"24"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }